import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/index.js';
function DisclaimerText(_ref) {
  let {
    inverse = false,
    withContrast = false,
    componentClass,
    ...rest
  } = _ref;
  let color = 'subdued-lightest';
  if (withContrast) color = 'subdued-lighter';
  if (inverse) color = 'inverse';
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    componentClass: componentClass || 'div',
    size: 200,
    color: color
  }, rest));
}
export default DisclaimerText;